/**
 * 注册渠道归因（channel_type / channel_param）
 * 仅用于注册接口；充值/套餐仍走既有 bdData。
 */

export var CHANNEL_STORAGE_KEY = 'channelData'

/**
 * 搜索引擎白名单（hostname 等于或子域结尾匹配）
 * 1 百度 baidu.com
 * 2 谷歌 google.com
 * 3 谷歌（香港） google.com.hk
 * 4 谷歌（中国） google.cn
 * 5 必应 bing.com
 * 6 搜狗 sogou.com
 * 7 360 搜索 so.com
 * 8 好搜 haosou.com
 * 9 神马 sm.cn
 * 10 中国搜索 chinaso.com
 * 11 头条 toutiao.com
 * 12-13 夸克 quark.cn / myquark.cn
 * 14 有道 youdao.com
 * 15 宜搜 easou.com
 * 16 搜搜 soso.com
 * 17 中搜 zhongsou.com
 * 18-19 花瓣 petalsearch.com / petal.org
 * 20-21 F搜 fsou.com / fsou.net
 * 22 秘迹 mijisou.com
 * 23 悟空 wukong.com
 * 24-25 雅虎 yahoo.com / yahoo.co.jp
 * 26 DuckDuckGo duckduckgo.com
 * 27-28 Yandex yandex.com / yandex.ru
 */
export var SEARCH_ENGINE_DOMAINS = [
  'baidu.com',
  'google.com',
  'google.com.hk',
  'google.cn',
  'bing.com',
  'sogou.com',
  'so.com',
  'haosou.com',
  'sm.cn',
  'chinaso.com',
  'toutiao.com',
  'quark.cn',
  'myquark.cn',
  'youdao.com',
  'easou.com',
  'soso.com',
  'zhongsou.com',
  'petalsearch.com',
  'petal.org',
  'fsou.com',
  'fsou.net',
  'mijisou.com',
  'wukong.com',
  'yahoo.com',
  'yahoo.co.jp',
  'duckduckgo.com',
  'yandex.com',
  'yandex.ru'
]

function isSearchEngineHost(hostname) {
  if (!hostname) return false
  var host = String(hostname).toLowerCase()
  for (var i = 0; i < SEARCH_ENGINE_DOMAINS.length; i++) {
    var domain = SEARCH_ENGINE_DOMAINS[i]
    if (host === domain || host.endsWith('.' + domain)) {
      return true
    }
  }
  return false
}

export function isSearchEngineReferrer(referrer) {
  if (!referrer) return false
  try {
    var url = new URL(referrer)
    return isSearchEngineHost(url.hostname)
  } catch (e) {
    return false
  }
}

export function getChannelData() {
  try {
    var raw = localStorage.getItem(CHANNEL_STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

export function setChannelData(snapshot) {
  localStorage.setItem(CHANNEL_STORAGE_KEY, JSON.stringify(snapshot))
}

/**
 * 进站采集：后到覆盖写入 channelData；
 * 有 bd_vid 时同步写入 bdData（供充值/套餐沿用）。
 */
export function captureChannelFromVisit() {
  var params = new URLSearchParams(window.location.search)
  var utmS = params.get('utm_s')
  var bdVid = params.get('bd_vid')
  var snapshot

  if (utmS) {
    // 运营/客服：只存 channel_param；4/5 由后端判定
    snapshot = { channel_param: utmS }
  } else if (bdVid) {
    var bdUrl = window.location.href
    snapshot = {
      channel_type: 1,
      bd_vid: bdVid,
      bd_url: bdUrl
    }
    localStorage.setItem('bdData', JSON.stringify({
      bd_vid: bdVid,
      bd_url: bdUrl
    }))
  } else {
    var referrer = document.referrer || ''
    if (isSearchEngineReferrer(referrer)) {
      snapshot = { channel_type: 2 }
    } else if (!referrer) {
      snapshot = { channel_type: 3 }
    } else {
      snapshot = { channel_type: 6 }
    }
  }

  setChannelData(snapshot)
  return snapshot
}

/**
 * 将渠道字段合并进注册请求体（会原地修改并返回 params）
 */
export function appendChannelData(params) {
  var data = params || {}
  var channel = getChannelData()
  if (!channel) return data

  if (channel.channel_param) {
    data.channel_param = channel.channel_param
    return data
  }

  if (channel.channel_type === 1) {
    data.channel_type = 1
    if (channel.bd_vid) data.bd_vid = channel.bd_vid
    if (channel.bd_url) data.bd_url = channel.bd_url
    return data
  }

  if (
    channel.channel_type === 2 ||
    channel.channel_type === 3 ||
    channel.channel_type === 6
  ) {
    data.channel_type = channel.channel_type
  }

  return data
}

/**
 * 注册成功后清除渠道快照与 URL 上的 utm_s；
 * 不清理 bdData / bd_vid。
 */
export function clearChannelData() {
  localStorage.removeItem(CHANNEL_STORAGE_KEY)
  try {
    var url = new URL(window.location.href)
    if (url.searchParams.has('utm_s')) {
      url.searchParams.delete('utm_s')
      window.history.replaceState({}, '', url.href)
    }
  } catch (e) {
    // ignore
  }
}
